import React, { useState, useEffect } from "react";
import axios from "axios";

const CourseContentPatterns = ({ platformUrl }) => {
    const [contentCounts, setContentCounts] = useState({});
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const courseUuid = params.get("courseUuid");

    useEffect(() => {
        if (!token || !courseUuid) {
            setError("Missing access token or course UUID. Please try again.");
            return;
        }

        const fetchContentRecursively = async (parentId = "ROOT") => {
            try {
                const response = await axios.get(
                    `${platformUrl}/learn/api/public/v1/courses/uuid:${courseUuid}/contents?parentId=${parentId}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                const items = response.data.results;
                let counts = {};

                // Count handlers in this level
                items.forEach(item => {
                    const handlerId = item.contentHandler?.id || "unknown";
                    counts[handlerId] = (counts[handlerId] || 0) + 1;
                });

                // Recursively count children
                for (const item of items) {
                    const childCounts = await fetchContentRecursively(item.id);
                    for (const [key, value] of Object.entries(childCounts)) {
                        counts[key] = (counts[key] || 0) + value;
                    }
                }

                return counts;
            } catch (err) {
                console.error(err);
                setError("Failed to fetch course content.");
                return {};
            }
        };

        const fetchAndCountContent = async () => {
            setLoading(true);
            const counts = await fetchContentRecursively();
            setContentCounts(counts);
            setLoading(false);
        };

        fetchAndCountContent();
    }, [platformUrl, courseUuid, token]);

    if (error) return <div style={{ color: "red" }}>{error}</div>;
    if (loading) return <div>Loading course content patterns…</div>;

    return (
        <div>
            <h2>Course Content Patterns</h2>
            <table border="1" cellPadding="8">
                <thead>
                <tr>
                    <th>Content Handler ID</th>
                    <th>Count</th>
                </tr>
                </thead>
                <tbody>
                {Object.entries(contentCounts).map(([handlerId, count]) => (
                    <tr key={handlerId}>
                        <td>{handlerId}</td>
                        <td>{count}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default CourseContentPatterns;
